import { Route, Routes } from 'react-router-dom';

import { RequirePermission } from './routing/RequirePermission.tsx';
import { ROUTES } from './routing/routes.ts';

import { LoginPage } from './pages/LoginPage.tsx';
import { DashboardShell } from './pages/DashboardShell.tsx';
import { NotFoundPage } from './pages/NotFoundPage.tsx';
import { DashboardPage } from './pages/dashboard/DashboardPage.tsx';
import { ReportsPage } from './pages/reports/ReportsPage.tsx';
import { ShopsPage } from './pages/shops/ShopsPage.tsx';
import { ShopDetailPage } from './pages/shops/ShopDetailPage.tsx';
import { OwnersPage } from './pages/owners/OwnersPage.tsx';
import { UsersPage } from './pages/users/UsersPage.tsx';
import { RolesPage } from './pages/roles/RolesPage.tsx';
import { ConfigPage } from './pages/config/ConfigPage.tsx';
import { PotdPage } from './pages/potd/PotdPage.tsx';

export function App(): React.JSX.Element {
  return (
    <Routes>
      <Route path={ROUTES.login} element={<LoginPage />} />

      <Route
        path="/"
        element={
          <RequirePermission permission={null}>
            <DashboardShell />
          </RequirePermission>
        }
      >
        <Route
          index
          element={
            <RequirePermission permission="reports:read">
              <DashboardPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.reports}
          element={
            <RequirePermission permission="reports:read">
              <ReportsPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.shops}
          element={
            <RequirePermission permission="shops:read">
              <ShopsPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.shopDetail}
          element={
            <RequirePermission permission="shops:read">
              <ShopDetailPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.owners}
          element={
            <RequirePermission permission="owners:read">
              <OwnersPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.users}
          element={
            <RequirePermission permission="users:manage">
              <UsersPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.roles}
          element={
            <RequirePermission permission="roles:manage">
              <RolesPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.config}
          element={
            <RequirePermission permission="config:manage">
              <ConfigPage />
            </RequirePermission>
          }
        />
        <Route
          path={ROUTES.potd}
          element={
            <RequirePermission permission="potd:manage">
              <PotdPage />
            </RequirePermission>
          }
        />
      </Route>

      <Route path={ROUTES.notFound} element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
